<template>
  <div>

    <!-- add/edit Event form -->
    <v-dialog v-model="dialog" max-width="500px" persistent>
      <div slot="activator">
        <v-tooltip right>
          <v-btn fab large color="primary darken-1" dark slot="activator" class="elevation-10">
            <v-icon>add</v-icon>
          </v-btn>
          <span>Add a new event</span>
        </v-tooltip>
      </div>

      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-select
                  :items="layouts" v-model="editedItem.layout.id" item-text="name" item-value="id"
                  label="Layout *" name="layout" prepend-icon="view_column"
                  auto :disabled="editedIndex !== -1"
                  :error-messages="form.errors.has('layout') ? form.errors.get('layout') : []"
                  @change="form.errors.clear('layout')"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field prepend-icon="event_note" label="Name *" name="name" v-model="editedItem.name"
                              :error-messages="form.errors.has('name') ? form.errors.get('name') : []"
                              @keypress="form.errors.clear('name')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                  ref="startDateMenu"
                  lazy
                  :close-on-content-click="false"
                  v-model="startDateMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  min-width="290px"
                  :return-value.sync="editedItem.startDate"
                >
                  <v-text-field
                    slot="activator"
                    label="Start Date *"
                    v-model="editedItem.startDate"
                    prepend-icon="event"
                    :error-messages="form.errors.has('startDate') ? form.errors.get('startDate') : []"
                    @keypress="form.errors.clear('startDate')"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.startDate" no-title scrollable>
                    <v-btn flat color="primary" @click="startDateMenu = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="$refs.startDateMenu.save(editedItem.startDate)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                  ref="startTimeMenu"
                  lazy
                  :close-on-content-click="false"
                  v-model="startTimeMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
                  :return-value.sync="editedItem.startTime"
                >
                  <v-text-field
                    slot="activator"
                    label="Start Time *"
                    v-model="editedItem.startTime"
                    prepend-icon="access_time"
                    :error-messages="form.errors.has('startDate') ? form.errors.get('startDate') : []"
                    @keypress="form.errors.clear('startDate')"
                    readonly
                  ></v-text-field>
                  <v-time-picker v-model="editedItem.startTime" @change="$refs.startTimeMenu.save(editedItem.startTime)"></v-time-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                  ref="endDateMenu"
                  lazy
                  :close-on-content-click="false"
                  v-model="endDateMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  min-width="290px"
                  :return-value.sync="editedItem.endDate"
                >
                  <v-text-field
                    slot="activator"
                    label="End Date *"
                    v-model="editedItem.endDate"
                    prepend-icon="event"
                    :error-messages="form.errors.has('endDate') ? form.errors.get('endDate') : []"
                    @keypress="form.errors.clear('endDate')"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="editedItem.endDate" no-title scrollable>
                    <v-btn flat color="primary" @click="endDateMenu = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="$refs.endDateMenu.save(editedItem.endDate)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm6>
                <v-menu
                  ref="endTimeMenu"
                  lazy
                  :close-on-content-click="false"
                  v-model="endTimeMenu"
                  transition="scale-transition"
                  offset-y
                  full-width
                  :nudge-right="40"
                  max-width="290px"
                  min-width="290px"
                  :return-value.sync="editedItem.endTime"
                >
                  <v-text-field
                    slot="activator"
                    label="End Time *"
                    v-model="editedItem.endTime"
                    prepend-icon="access_time"
                    :error-messages="form.errors.has('endDate') ? form.errors.get('endDate') : []"
                    @keypress="form.errors.clear('endDate')"
                    readonly
                  ></v-text-field>
                  <v-time-picker v-model="editedItem.endTime" @change="$refs.endTimeMenu.save(editedItem.endTime)"></v-time-picker>
                </v-menu>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary darken-1" flat @click.native="close('edit')">
            <v-icon left dark>arrow_back</v-icon>
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" @click.native="save" :loading="formLoading">
            <v-icon left dark>save</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End add/edit Event form -->

    <!-- booking preview -->
    <v-dialog v-model="bookingDialog" persistent max-width="1200">
      <v-card>
        <v-toolbar card dark color="primary">
          <v-btn icon @click.native="bookingDialog = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ editedItem.layout.name }}
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <!--c-slots was here-->
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end booking preview -->

    <v-card class="elevation-5">
      <v-card-title>
        <span class="headline">Events</span>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
          @keyup.enter="searchEvents"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="events"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="totalEvents"
        :loading="tableLoading"
        :must-sort="true"
      > <!-- :search="search" -->
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td style="text-align: center;" nowrap>{{ props.item.id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.type }}</td>
          <td>{{ props.item.startTime }}</td>
          <td>{{ props.item.endTime }}</td>
          <td>{{ props.item.layout.name }}</td>
          <td class="justify-center layout px-0">

            <v-layout v-if="props.item.layout.type === 'CINEMA'" row justify-center>
              <div slot="activator">
                <v-tooltip top>
                  <v-btn icon class="mx-0" slot="activator" @click="editItem(props.item, 'booking')">
                    <v-icon color="primary">check_circle</v-icon>
                  </v-btn>
                  <span>Booking preview</span>
                </v-tooltip>
              </div>
            </v-layout>

            <v-tooltip top>
              <v-btn icon class="mx-0" @click="editItem(props.item, 'edit')" slot="activator">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon class="mx-0" @click="deleteItem(props.item)" slot="activator">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </template>
        <template v-if="noEventsFound" slot="no-data">
          <v-alert :value="true" color="error" icon="warning">
            Sorry, no events found in the database :(
          </v-alert>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>

    <v-snackbar
      :timeout="snackbarTimeout"
      :color="snackbarColor"
      v-model="snackbar"
      top
    >
      {{ snackbarText }}
      <v-btn dark flat @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import moment from 'moment';

  export default {
    name: "Events",

    props: {
      // showAddModal: Boolean
    },

    data: () => ({
      search: '',
      noEventsFound: false,
      bookingDialog: false,
      slotsLayoutName: '',
      selectedSeats: [],
      startDateMenu: false,
      startTimeMenu: false,
      endDateMenu: false,
      endTimeMenu: false,
      headers: [
        { text: '#', value: 'id', align: 'center', width: '5px' },
        { text: 'Name', value: 'name' },
        { text: 'Type', value: 'type' },
        { text: 'Start Time', value: 'startTime' },
        { text: 'End Time', value: 'endTime' },
        { text: 'Location (Layout)', value: 'layout.name' },
        { text: 'Actions', value: 'name', sortable: false, width: '5px', align: 'center' }
      ],
      events: [],
      totalEvents: 0,
      pagination: {
        descending: true
      },
      rowsPerPageItems: [100, 50, 25],
      layouts: [],
      tableLoading: true,
      editedIndex: -1,
      dialog: false,
      formLoading: false,
      snackbar: false,
      snackbarColor: '',
      snackbarMode: '',
      snackbarTimeout: 6000,
      snackbarText: '',
      editedItem: {
        layout: {},
        id: 0,
        name: '',
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null
      },
      defaultItem: {
        layout: {},
        id: 0,
        name: '',
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null
      },
      form: new Form({
        // layoutId: '',
        name: '',
        startTime: '',
        endTime: ''
      }),
      searchMode: false
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Event' : 'Edit Event';
      }
    },

    watch: {
      dialog (val) {
        val || this.close('edit');
      },
      bookingDialog (val) {
        val || this.close('booking');
      },
      pagination: {
        handler () {
          this.getEvents();
        },
        deep: true
      },
      search (val) {
        this.searchMode = !(val = "");
      }
    },

    created() {
      // this.dialog = this.showAddModal;
      this.setActiveMenu('Events');
      this.setActiveSubmenu('All Events');
      this.getLayouts();
      this.getEvents();
    },

    methods: {
      /* Search layouts */
      searchEvents() {
        this.tableLoading = true;
        this.pagination.page = 1;
        this.getEvents();
      },

      /* Fetch list of all events from the server */
      getEvents() {
        let page = this.pagination.page - 1;
        let size = this.pagination.rowsPerPage;
        let sortBy = this.pagination.sortBy;
        let descending = this.pagination.descending;
        if (page >= 0) {
          this.tableLoading = true;
          let url = '';
          if (this.searchMode) {
            url = BACKEND_URL + '/api/paginated-events/search' + '?match_seq=' + this.search + '&page=' + page + '&size=' + size + '&sort_by=' + sortBy + '&desc=' + descending;
          } else
            url = BACKEND_URL + '/api/paginated-events' + '?page=' + page + '&size=' + size + '&sort_by=' + sortBy + '&desc=' + descending;
          axios.get(url).then(({data}) => {

            this.events = (data && data.content && data.content.length > 0) ? data.content : [];
            this.totalEvents = (data && data.totalElements >= 0) ? data.totalElements : 0;

            // this.events = data;
            this.noEventsFound = (!this.events.length > 0);
            this.tableLoading = false;
            //   console.log(data);
          }).catch((error) => {
            this.tableLoading = false;
            if (error.message === 'Network Error') {
              console.log('Cannot connect to server');
            } else {
              console.log(error.response.data);
            }
          });
        }
      },

      /* Fetch list of Layouts form the server */
      getLayouts() {
        axios.get(BACKEND_URL+'/api/layouts').then(({data})=>{
          this.layouts = (data && data.length > 0) ? data : [];
          // console.log(data);
        }).catch((error)=>{
          if (error.message === 'Network Error') {
            console.log('Cannot connect to server');
          } else {
            console.log(error.response.data);
          }
        });
      },

      /* Pass the selected item to the edit dialog and show the dialog */
      editItem (item, modal) {
        this.editedIndex = this.events.indexOf(item);
        this.editedItem = Object.assign({}, item);
        // console.log(item.layout.id);
        this.editedItem.startDate = moment(item.startTime).format('YYYY-MM-DD');
        this.editedItem.startTime = moment(item.startTime).format('HH:mm');
        this.editedItem.endDate = moment(item.endTime).format('YYYY-MM-DD');
        this.editedItem.endTime = moment(item.endTime).format('HH:mm');

        if (modal === 'edit') {
          this.dialog = true;
        } else if (modal === 'booking') {
          this.bookingDialog = true;
          this.selectedSeats = [];
        }
      },

      /* Delete an item */
      deleteItem (item) {
        const index = this.events.indexOf(item);
        let prompt = confirm("Are you sure you want to permanently delete this event from the database? \nThis action cannot be undone.");
        if (prompt === true) {
          axios.delete(BACKEND_URL+'/api/events/' + item.id).then(({data})=>{
            this.events.splice(index, 1);
            this.totalEvents -= 1;
            console.log(data);
          }).catch((error)=>{
            if (error.message === 'Network Error') {
              console.log('Cannot connect to server');
            } else {
              console.log(error.response.data);
            }
          });
        }
      },

      /* Reset the new/edit dialog form when it closes */
      close (modal) {
        if (modal === 'edit') {
          this.dialog = false;
        } else if (modal === 'booking') {
          this.bookingDialog = false;
        }
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      /* Save/edit dialogue form content */
      save () {
        this.formLoading = true;

        // this.form.layoutId = this.editedItem.layoutId;
        this.form.name = this.editedItem.name;
        this.form.startTime = this.editedItem.startDate + ' ' + this.editedItem.startTime;
        this.form.endTime = this.editedItem.endDate + ' ' + this.editedItem.endTime;

        if (this.editedIndex > -1) {
          // console.log(this.form);

          this.form.put(BACKEND_URL+'/api/events/'+this.editedItem.id).then(({data}) => {
            console.log(data);
            Object.assign(this.events[this.editedIndex], data);

            this.formLoading = false;
            this.close('edit');
            this.showSnackbar('success', 'Event details successfully updated!');
            // this.layouts = [];
          }).catch((error) => {
            console.log(error);
            this.formLoading = false;
          });
        } else {
          this.form.post(BACKEND_URL+'/api/layouts/'+this.editedItem.layout.id+'/events').then(({data}) => {
            console.log(data);
            this.events.unshift(data);
            this.totalEvents += 1;

            this.formLoading = false;
            this.close('edit');
            this.showSnackbar('success', 'The resource has been successfully created!');
            // this.layouts = [];

          }).catch((error) => {
            console.log(error);
            this.showSnackbar('error', error.status + ' ' + error.error + ': ' + error.message);
            this.formLoading = false;
          });
        }
      },

      showSnackbar(snackbarColor, snackbarText) {
        this.snackbarColor = snackbarColor;
        this.snackbarText = snackbarText;
        this.snackbar = true;
      },

      navigateTo(path) {
        this.$router.push(path);
      },

      /* map vuex actions */
      ...mapActions([
        'setActiveMenu',
        'setActiveSubmenu'
      ]),

      /* handle event's layout seat selection */
      selectSeat(slotIndex) {
        // Set seat reservation status
        console.log('should reflect seat selection: ' + slotIndex);
        let selectedSeat = this.selectedLayout.slots[slotIndex];
        selectedSeat.reserved = ! selectedSeat.reserved;
        this.selectedLayout.slots.splice(slotIndex, 1, selectedSeat);
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/events/Events.vue